// extracted by mini-css-extract-plugin
module.exports = {"teaserBoardContainer":"_2BKUffunY6SCQEiwKP0s_C","loadMore":"_38c902xbvecmK_xxq9fdZF","title":"_2J46a-mVAG5qK3aWC--1rE"};